import moment from 'moment';
import {StyleProp, ImageStyle, ViewStyle} from 'react-native';
import Styles from 'src/components/Styles';
import MenuService from 'src/services/MenuService';
import {RecentOrderItemType} from 'src/types/RecentOrders';

export const getMenuItemUrl = (scanCode: string) => {
  const product = MenuService.getProductByScanCode(scanCode);
  const fullProduct = MenuService.getProduct(product?.id);

  return fullProduct?.smallimageurl;
};

export const getTimeAndDate = (dateString: string): string =>
  moment(dateString).format('DD/MM/YY - h:mm A');

export const calculateTotal = (data: RecentOrderItemType[]) => {
  let totalSum = 0;
  data.forEach((item) => {
    if (item.available) {
      const productPrice = item.price;
      const modifierPrices = item.modifiers.reduce((sum, modifier) => {
        const modifierPrice = modifier.price || 0;
        return sum + modifierPrice;
      }, 0);
      totalSum = productPrice + modifierPrices;
    }
  });
  return totalSum;
};

export const calculateRecentTotal = (item: RecentOrderItemType): number => {
  let totalSum = 0;

  if (item.available) {
    const productPrice = Number(item.price) || 0;
    const modifierPrices = item.modifiers?.reduce(
      (sum, modifier) => sum + Number(modifier.price || 0),
      0,
    );
    totalSum = productPrice + modifierPrices;
  }

  return totalSum;
};

export const getModifierImageStyle = (modifiers): StyleProp<ImageStyle> => {
  if (modifiers && modifiers?.length > 0) {
    return {alignSelf: 'flex-start'};
  } else {
    return {alignSelf: 'center'};
  }
};

export const getModifierTextStyle = (ordItem): StyleProp<ViewStyle> => {
  if (isModifiersPresent(ordItem.modifiers)) {
    return {alignSelf: 'flex-start'};
  } else {
    return {
      alignSelf: 'center',
      marginBottom: ordItem.available ? Styles.Spacing.m2 : 0,
    };
  }
};

export const isModifiersPresent = (modifiers) => {
  if (modifiers?.length > 0) {
    return true;
  }
  return false;
};
